// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-lOV","left":"styles_left__1NTSj","desktopActions":"styles_desktopActions__KOM8W","title":"styles_title__3JrAE"};